export default function LoadingBar(options={}){
    let bar_container_element, bar_element, date_element, timer=options.timer || 60000

    let interval
    this.generate = () =>{
        bar_container_element = createElement('div','loading-bar-container')
        
        bar_element = createElement('div', 'bar-container')
        $(bar_element).html("<div class='bar'></div>")
        
        date_element = createElement('div', 'date-container')

        $(date_element).html("<div class='text font-weight-bold'> - </div>")

        $(bar_container_element).append(bar_element,date_element)

        $(document).find('body').after(bar_container_element)

        this.updatePosition()

    }
    this.updatePosition = () =>{
        let HEADER_SIZE = $("#main_header").outerHeight();
        $(bar_container_element).css({
            top: HEADER_SIZE
        })

    }

    this.updateText = text =>{
        $(date_element).html("<div class='text font-weight-bold'>"+text+"</div>")
    }

    this.stop = _ =>{
        if(interval){
            clearInterval(interval)
        }
        this.reset()
    }

    this.reset = () =>{
        let elem = $(bar_element).find('.bar')[0]
        elem.style.width = "100%";
    }
    this.move = _ =>{
        let elem = $(bar_element).find('.bar')[0]
        let width = 100
        if(interval){
            this.stop()
        }

        interval = setInterval(frame, 10)
        
        let duration = timer

        elem.style.width = width + "%";

        function frame(){
            if (width <= 0) {
                clearInterval(interval);
              } else {
                width -= 100 / (duration / 10);
                elem.style.width = width + "%";
              }
        }

    }
    function createElement(type, classes){
        let el = document.createElement(type)
        $(el).addClass(classes)
        return el 
    }
}